module.exports = __webpack_public_path__ + "img/xinxiang.f3070ec2.png";